import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAuthData } from "./authSlice";

export const fetchSingleProduct = createAsyncThunk(
  "singleproduct/fetch",
  async ({ product_id }, { rejectWithValue }) => {
    try {
      const authData = getAuthData();

      if (
        !authData?.token ||
        !authData?.groupCode ||
        !authData?.companyCode ||
        !authData?.aux
      ) {
        throw new Error("signin");
      }

      const response = await fetch(
        process.env.REACT_APP_API_URL + "clientPortal/CatalogueProduct",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            login: [
              ["token", "=", authData?.token],
              ["group_code", "=", authData?.groupCode],
              ["company_code", "=", authData?.companyCode],
              ["user_id", "=", authData?.user_id],
            ],
            params: [
              ["product_id", "=", product_id],
              ["aux", "=", authData?.aux],
            ],
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to fetch product info");
      }

      const data = await response.json();

      return data;
    } catch (error) {
      return rejectWithValue("Failed to fetch product info");
    }
  },
);

const productCatalogueSlice = createSlice({
  name: "productCatalogue",
  initialState: {
    data: null,
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSingleProduct.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSingleProduct.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchSingleProduct.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default productCatalogueSlice.reducer;
